<template>
    <div>Este es el Welcome</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data: () => ({}),
    computed: {
        ...mapGetters(['polls']),
    },
}
</script>
